"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determinParent = void 0;
function determinParent(object, safeDepth = 10) {
    if (object.parent === null)
        return undefined; // not ok, object is scene or camera
    if (safeDepth === 0)
        return undefined; // swam too deep
    if (object.parent.type === "Scene" /* SCENE */)
        return object; // found the root node
    return determinParent(object.parent, --safeDepth);
}
exports.determinParent = determinParent;
